import * as React from 'react';
import { Heading } from '@uhg-abyss/web/ui/Heading';
import { Text } from '@uhg-abyss/web/ui/Text';

export default function PageNotFound() {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        minHeight: '80vh',
        padding: '24px',
        textAlign: 'center',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {/* Decorative floating circles */}
      <div
        style={{
          position: 'absolute',
          top: '-60px',
          right: '-60px',
          width: '220px',
          height: '220px',
          borderRadius: '50%',
          background:
            'radial-gradient(circle, rgba(0,168,225,0.12) 0%, transparent 70%)',
          animation: 'float 6s ease-in-out infinite',
        }}
      />
      <div
        style={{
          position: 'absolute',
          bottom: '-40px',
          left: '-40px',
          width: '180px',
          height: '180px',
          borderRadius: '50%',
          background:
            'radial-gradient(circle, rgba(0,38,119,0.1) 0%, transparent 70%)',
          animation: 'float 8s ease-in-out infinite reverse',
        }}
      />
      <div
        style={{
          position: 'absolute',
          top: '30%',
          left: '10%',
          width: '100px',
          height: '100px',
          borderRadius: '50%',
          background:
            'radial-gradient(circle, rgba(0,168,225,0.07) 0%, transparent 70%)',
          animation: 'float 7s ease-in-out infinite 1s',
        }}
      />

      {/* Astronaut / lost icon SVG */}
      <div
        style={{
          marginBottom: '16px',
          animation: 'drift 4s ease-in-out infinite',
        }}
      >
        <svg
          width="120"
          height="120"
          viewBox="0 0 120 120"
          fill="none"
          style={{ filter: 'drop-shadow(0 8px 24px rgba(0,38,119,0.15))' }}
        >
          {/* Planet */}
          <circle cx="60" cy="60" r="40" fill="url(#planetGrad)" />
          <ellipse
            cx="60"
            cy="60"
            rx="55"
            ry="12"
            stroke="#00a8e1"
            strokeWidth="2.5"
            fill="none"
            opacity="0.5"
            strokeDasharray="6 4"
          />
          {/* Crater details */}
          <circle cx="48" cy="50" r="6" fill="rgba(255,255,255,0.15)" />
          <circle cx="70" cy="65" r="4" fill="rgba(255,255,255,0.12)" />
          <circle cx="55" cy="72" r="3" fill="rgba(255,255,255,0.1)" />
          {/* Stars */}
          <circle cx="15" cy="20" r="2" fill="#002677" opacity="0.6">
            <animate
              attributeName="opacity"
              values="0.6;1;0.6"
              dur="2s"
              repeatCount="indefinite"
            />
          </circle>
          <circle cx="105" cy="25" r="1.5" fill="#00a8e1" opacity="0.5">
            <animate
              attributeName="opacity"
              values="0.5;1;0.5"
              dur="3s"
              repeatCount="indefinite"
            />
          </circle>
          <circle cx="100" cy="90" r="2" fill="#002677" opacity="0.4">
            <animate
              attributeName="opacity"
              values="0.4;0.9;0.4"
              dur="2.5s"
              repeatCount="indefinite"
            />
          </circle>
          <circle cx="20" cy="95" r="1.5" fill="#00a8e1" opacity="0.5">
            <animate
              attributeName="opacity"
              values="0.5;1;0.5"
              dur="1.8s"
              repeatCount="indefinite"
            />
          </circle>
          <defs>
            <linearGradient id="planetGrad" x1="20" y1="20" x2="100" y2="100">
              <stop offset="0%" stopColor="#002677" />
              <stop offset="100%" stopColor="#00a8e1" />
            </linearGradient>
          </defs>
        </svg>
      </div>

      {/* Large 404 display */}
      <div
        style={{
          fontSize: 'clamp(80px, 18vw, 160px)',
          fontWeight: 900,
          lineHeight: 1,
          background:
            'linear-gradient(135deg, #002677 0%, #00a8e1 50%, #002677 100%)',
          backgroundSize: '200% 200%',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          marginBottom: '4px',
          userSelect: 'none',
          animation: 'shimmer 3s ease-in-out infinite',
          letterSpacing: '-4px',
          textShadow: 'none',
          filter: 'drop-shadow(0 4px 12px rgba(0,38,119,0.15))',
        }}
      >
        404
      </div>

      <Heading
        display="h1"
        style={{
          fontSize: 'clamp(22px, 4vw, 38px)',
          marginBottom: '12px',
          color: '#002677',
          fontWeight: 700,
          letterSpacing: '-0.5px',
        }}
      >
        Oops! Page Not Found
      </Heading>

      <Text
        fontWeight={700}
        style={{
          fontSize: 'clamp(14px, 2vw, 17px)',
          maxWidth: '440px',
          lineHeight: 1.7,
          color: '#5a6577',
          marginBottom: '32px',
        }}
      >
        We couldn’t find the page you requested.
      </Text>

      {/* Keyframe animations */}
      <style>{`
        @keyframes shimmer {
          0%, 100% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
        }
        @keyframes drift {
          0%, 100% { transform: translateY(0px) rotate(0deg); }
          50% { transform: translateY(-12px) rotate(3deg); }
        }
        @keyframes float {
          0%, 100% { transform: translateY(0px) scale(1); }
          50% { transform: translateY(-20px) scale(1.05); }
        }
      `}</style>
    </div>
  );
}
